import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StorageService} from '../../shared/services/storage.service';
import {CoreConfigService} from '../../../@core/services/config.service';
import {StateService} from '../../shared/services/state.service';
import {repeaterAnimation} from 'app/main/animations/form-repeater.animation';
import {AlertService} from '../../shared/services/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder} from '@angular/forms';
import {ProductService} from '../../shared/services/product.service';
import {PackageService} from '../../shared/services/package.service';
import {Router} from '@angular/router';
import {OrderService} from '../../shared/services/order.service';
import {SessionService} from '../../shared/services/session.service';
import {UserOrderService} from '../../shared/services/user-order.service';
import {StockistService} from '../../shared/services/stockist.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [repeaterAnimation]
})
export class DashboardComponent implements OnInit, AfterViewInit {
    user: any;
    states: any = [];
    data: any;
    id: any;
    public coreConfig: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    productCount: any = 0;
    packageCount: any = 0;
    recentProductOrder: any = 0;
    stockistProductOrder: any = 0;
    userProductOrderCount: any = 0;
    stockistProductOrderDelivery: any = 0;
    stockistProductOrderPlaced: any = 0;
    userPackageOrderCount: any = 0;
    recentUserProductOrder: any = 0;
    userData: any;
    totalAmount: any = 0;
    sessions: any = [];
    sessionId: any;
    submitting: any = false;

    constructor(public _coreConfigService: CoreConfigService,
                public stateService: StateService,
                public modalService: NgbModal,
                private alertService: AlertService,
                private fb: FormBuilder,
                private stockistService: StockistService,
                private productService: ProductService,
                private packageService: PackageService,
                private orderService: OrderService,
                private sessionService: SessionService,
                private userOrderService: UserOrderService,
                private router: Router) {
        this.user = StorageService.getItem('self');
    }


    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.refresh();
    }

    refresh() {
        this.getStates();
        this.getProductCount();
        this.getPackageCount();
        this.getSessions();
        this.getDetail();
    }

    getSessions() {
        this.sessions = [];
        this.sessionService.get({'page': -1}).subscribe(data => {
            this.sessions = [];
            if (data && data['data'].length > 0) {
                this.sessions = data['data'];
                if (this.sessions && this.sessions.length > 0) {
                    this.sessions.forEach(session => {
                        if (session && session['status'] === 'ACTIVE' && session['default_session'] === 'ACTIVE') {
                            this.sessionId = session['id'];
                        }
                    });
                    this.getRecentOrderCount();
                    this.getStockistOrderCount();
                    this.getStockistOrderDeliveryCount();
                    this.getStockistOrderPlacedCount();
                    this.getUserOrderCount();
                    this.getUserPackageCount();
                    this.getUserRecentOrderCount();
                }
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }

    getProductCount(params: any = {}) {
        this.productService.count(params).subscribe(data => {
            if (data) {
                this.productCount = data;
            }
        });
    }

    getPackageCount(params: any = {}) {
        this.packageService.count(params).subscribe(data => {
            if (data) {
                this.packageCount = data;
            }
        });
    }

    getRecentOrderCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.orderService.count(params).subscribe(data => {
            if (data) {
                this.recentProductOrder = data;
            }
        });
    }

    getStockistOrderCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.orderService.count(params).subscribe(data => {
            if (data) {
                this.stockistProductOrder = data;
            }
        });
    }

    getStockistOrderDeliveryCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.orderService.deliveryCount(params).subscribe(data => {
            if (data) {
                this.stockistProductOrderDelivery = data;
            }
        });
    }

    getStockistOrderPlacedCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.orderService.placedOrderCount(params).subscribe(data => {
            if (data) {
                this.stockistProductOrderPlaced = data;
            }
        });
    }

    getUserOrderCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userOrderService.getProductsCount(params).subscribe(data => {
            if (data) {
                this.userProductOrderCount = data;
            }
        });
    }

    getUserPackageCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userOrderService.getPackagesCount(params).subscribe(data => {
            if (data) {
                this.userPackageOrderCount = data;
            }
        });
    }

    getUserRecentOrderCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userOrderService.getProductsCount(params).subscribe(data => {
            if (data) {
                this.recentUserProductOrder = data;
            }
        });
    }

    getDetail() {
        this.stockistService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                const walletAmount = (this.userData && this.userData['wallet_amount']) ? parseFloat(this.userData['wallet_amount']) : 0;
                const activationAmount = (this.userData && this.userData['activation_amount']) ? parseFloat(this.userData['activation_amount']) : 0;
                this.totalAmount = walletAmount + activationAmount;
            }
        });
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }
}
